// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3bdQs","svg":"svg-1BoTL","hitTarget":"hitTarget-1qBWI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/_svg.css
// module id = 1283
// module chunks = 1